import React, { useState, useEffect } from "react";
import { Modal } from '../../components';
import {
  getCustomerTypes,
  getSuppliers,
  getLocations,
  getLocationById,
  updateLocation,
  createLocation,
  deleteLocationById,
} from '../../services';
import MultiSelect from "react-multi-select-component";

const LocationCreate = (props) => {
  const [location, setLocation] = useState();
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [username, setUsername] = useState("");
  const [customerTypeArray, setCustomerTypeArray] = useState();
  const [supplierArray, setSupplierArray] = useState();
  const [locationsArray, setLocationsArray] = useState([]);
  const [customerType, setCustomerType] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [newLocation, setNewLocation] = useState(false);
  const [deleteLocationId, setDeleteLocationId] = useState();

  const openModal = (locationId) => {
    document.querySelector('.overlay').classList.toggle('modal__active');
    setDeleteLocationId(locationId)
  }

  const deleteLocation = () => {
    deleteLocationById(deleteLocationId).then(() => {
      document.querySelector('.overlay').classList.toggle('modal__active');
      setDeleteLocationId(null);
      setLocation(null);
      getLocations(props.customerId).then((list) => {
        setLocationsArray(list);
      });
    })
  }

  useEffect(() => {
    getLocations(props.customerId).then((list) => {
      setLocationsArray(list);
    });

    getCustomerTypes().then((types) => {
      // Get all customer types and create a options list to use in the selectbox
      const typeOptions = types.customer_types.map((type) => ({
        label: type.name,
        value: type.id,
      }));
      setCustomerTypeArray(typeOptions);
    });

    getSuppliers().then((types) => {
      // Get all suppliers and create a options list to use in the selectbox
      const typeOptions = types.suppliers.map((type) => ({
        label: type.name,
        value: type.id,
      }));
      setSupplierArray(typeOptions);
    });
  }, []);

  const resetForm = () => {
    setLocation();
    setName("")
    setAddress("")
    setPostal("")
    setPhone("")
    setEmail("")
    setCity("")
    setSupplier([])
    setCustomerType([])
    setUsername("")
    setFullName("")
    setPassword("")
  }

  const submitLocation = () => {
    if (newLocation) {
      createLocation(
          props.customerId,
          name,
          supplier,
          customerType,
          username,
          address,
          postal,
          phone,
          email,
          city,
          fullName,
      ).then(() => {
        setNewLocation(false);
        setLocation();
        resetForm();
        getLocations(props.customerId).then((list) => {
          setLocationsArray(list);
        });
      })

    } else {
      updateLocation(
          location,
          name,
          supplier,
          customerType,
          username,
          address,
          postal,
          phone,
          email,
          city,
          fullName,
          password
      ).then(
          (res) => {
            props.next();
          }
      );
    }
  };

  const selectLocation = (locationId) => {
    if(locationId !== 0) {
      setNewLocation(false);
      setLocation(locationId);
      getLocationById(locationId).then(res => {
        setName(res.name)
        setAddress(res.address)
        setPostal(res.postal)
        setPhone(res.phone)
        setEmail(res.email)
        setCity(res.city)
        setSupplier(res.suppliers)
        setCustomerType(res.customer_types)
        setUsername(res.username)
        setFullName(res.contact)
        setPassword("")
      })
    }
    else {
      document.getElementById("selectbox__location").value = "0";
      resetForm();
    }
  }

  return (<>
    <Modal header="Weet je zeker dat je deze locatie wilt verwijderen?">
      <button onClick={deleteLocation} className="button__delete">Verwijderen</button>
    </Modal>
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Selecteer een locatie</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">Locatie</span>
          <select
            required="true"
            id="selectbox__location"
            onChange={(e) => selectLocation(e.target.value)}
            className="form__fields__field__input"
          >
            <option value="">Selecteer een locatie</option>
            {locationsArray}
          </select>
        </div>
        <button
            className="form__container__add__button"
            onClick={() => {
              selectLocation(0)
              setNewLocation(true)
            }}
        >
          <i className="fas fa-plus"></i>
        </button>
      </div>
      {(location || newLocation) &&
        <div className="form__container__content__category">
          <span>Locatiegegevens</span>
        </div>
      }
      {(location || newLocation) &&
        <div className="form__fields">
          <div className="form__fields__field">
            <span className="form__fields__field__label">Locatienaam</span>
            <input
              // required="true"
              onChange={(e) => setName(e.target.value)}
              type="text"
              value={name}
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Adres</span>
            <input
              // required="true"
              onChange={(e) => setAddress(e.target.value)}
              type="text"
              value={address}
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Postcode</span>
            <input
              // required="true"
              onChange={(e) => setPostal(e.target.value)}
              type="text"
              value={postal}
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Plaats</span>
            <input
              // required="true"
              onChange={(e) => setCity(e.target.value)}
              type="text"
              value={city}
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Naam contactpersoon</span>
            <input
              // required="true"
              onChange={(e) => setFullName(e.target.value)}
              type="text"
              value={fullName}
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">E-mailadres</span>
            <input
              // required="true"
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              value={email}
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Telefoonnummer</span>
            <input
              // required="true"
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              value={phone}
              className="form__fields__field__input"
            />
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Klanttypering</span>
            {customerTypeArray && (
              <MultiSelect
                overrideStrings={{
                  selectSomeItems: "Selecteren...",
                  allItemsAreSelected: "Alles is geselecteerd",
                  selectAll: "Selecteer alles",
                  search: "Zoeken",
                  clearSearch: "Wis zoekopdracht",
                }}
                options={customerTypeArray}
                value={customerType}
                onChange={setCustomerType}
                labelledBy={"Select"}
              />
            )}
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Leverancier</span>
            {supplierArray && (
              <MultiSelect
                overrideStrings={{
                  selectSomeItems: "Selecteren...",
                  allItemsAreSelected: "Alles is geselecteerd",
                  selectAll: "Selecteer alles",
                  search: "Zoeken",
                  clearSearch: "Wis zoekopdracht",
                }}
                options={supplierArray}
                value={supplier}
                onChange={setSupplier}
                labelledBy={"Select"}
              />
            )}
          </div>
          <div className="form__fields__field">
            <span className="form__fields__field__label">Gebruikersnaam voor locatiemedewerkers</span>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              disabled={!newLocation}
              className="form__fields__field__input"
            />
          </div>
          {!newLocation &&
          <div className="form__fields__field">
            <span className="form__fields__field__label">Nieuw wachtwoord voor locatiemedewerkers</span>
            <input
              type="password"
              placeholder="Laat dit veld leeg als u het wachtwoord niet wilt wijzigen"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              className="form__fields__field__input"
            />
          </div>
          }
        </div>
      }
      {(location || newLocation) &&
        <>
          <button
            className="form__container__content__button"
            onClick={() => submitLocation()}
          >
            OPSLAAN <i className="fas fa-arrow-right"></i>
          </button>
          <button onClick={() => openModal(location)} className="form__container__content__button btn-danger">Verwijderen</button>
        </>
      }
      <button
        className="form__container__content__button btn-success"
        onClick={() => props.next()}
      >
        Naar afdelingen bewerken  <i className="fas fa-arrow-right"></i>
      </button>
    </div>
  </>);
};

export default LocationCreate;
